// NPM Imports
import React, { memo } from "react";
import PropTypes from "prop-types";
import { Label, Input } from "@revvsales/components";

// Components Imports

// Internal Imports
import { GlobalUtils } from "../../../utils";
import { GRID } from "../../../constants";

// Destructuring
const { numberForamting } = GlobalUtils;
const { PRICING_METHODS } = GRID;

const ProductListItem = memo(({ currencySymbol, data, onSelect }) => (
  <div
    className={`productlistitem-wrapper ${
      data.isDisabled ? "is-disabled" : ""
    }`}>
    <Label
      htmlFor={`catalog-item-${data.id}`}
      className="productlistitem-checkbox-wrapper">
      <input
        data-test="product-catalog-list-checkbox"
        checked={data.isChecked && !data.isDisabled}
        className="productlistitem-hidden-checkbox"
        disabled={data.isDisabled}
        id={`catalog-item-${data.id}`}
        onChange={e => onSelect(data.id, e.target.checked)}
        tabIndex="0"
        type="checkbox"
      />
      <div className="productlistitem-checkbox">
        <Input
          checked={data.isChecked && !data.isDisabled}
          disabled={data.isDisabled}
          readOnly
          type="checkbox"
          value=""
        />
      </div>
      <div className="productlistitem-detail">
        <span className="productlistitem-name">{data.product.name}</span>
        <span className="productlistitem-description">{data.description}</span>
        <span className="productlistitem-sku">
          SKU: {data.sku ? data.sku : data.product.code}
        </span>
        <span
          className={`productlistitem-added-item ${
            data.isDisabled ? "is-disabled" : ""
          }`}>
          Item already added
        </span>
      </div>
      <div className="productlistitem-type">
        <span className="productlistitem-title">Product type</span>
        <span className="productlistitem-productType">{data.product.type}</span>
      </div>
      <div className="productlistitem-price">
        <span className="productlistitem-title">Base Price</span>
        <span>
          {numberForamting(
            (data.price.type !== PRICING_METHODS.PERCENTAGE_OF_TOTAL &&
              data.price.value) ||
              0,
            currencySymbol,
          )}
        </span>
      </div>
    </Label>
  </div>
));
ProductListItem.defaultProps = {};

ProductListItem.propTypes = {
  data: PropTypes.PropTypes.shape({}).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default ProductListItem;



// WEBPACK FOOTER //
// ./src/components/Catalog/ProductListItem/index.js